module.exports = __webpack_public_path__ + "media/images/sp_header_btn_my_page-9cb9c6d2d42fa0d3dbbb70fae921390b.png";